import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "block" }
const _hoisted_2 = {
  class: "",
  style: {"line-height":"1.25"}
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_4 = { class: "d-flex align-items-center text-hover-primary cursor-pointer" }
const _hoisted_5 = { class: "symbol symbol-30 symbol-light-success me-3" }
const _hoisted_6 = {
  class: "text-dark-50",
  style: {"line-height":"1.25"}
}
const _hoisted_7 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_8 = {
  key: 0,
  class: "badge badge-light-success"
}
const _hoisted_9 = {
  key: 1,
  class: "badge badge-light-danger"
}
const _hoisted_10 = { class: "fs-8 fw-bold text-info" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_avatar = _resolveComponent("el-avatar")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_el_dialog = _resolveComponent("el-dialog")!
  const _component_ModalSearch = _resolveComponent("ModalSearch")!
  const _component_ModalPerfil = _resolveComponent("ModalPerfil")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_el_dialog, {
      title: `${_ctx.t('selection')} ${_ctx.sport?.name}`,
      modelValue: _ctx.gblDialog,
      "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.gblDialog) = $event)),
      class: "dialog-custom rounded",
      onOpened: _ctx.onOpened,
      onClosed: _ctx.onClosed,
      "close-on-click-modal": false,
      "close-on-press-escape": false,
      top: "0vh",
      draggable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_input, {
          modelValue: _ctx.searchText,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchText) = $event)),
          size: "large",
          placeholder: _ctx.t('search'),
          "prefix-icon": _ctx.Search,
          disabled: _ctx.loaderTable,
          clearable: "",
          class: "w-100 mb-4"
        }, null, 8, ["modelValue", "placeholder", "prefix-icon", "disabled"]),
        _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
          (_ctx.filteredList.length>0)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _withDirectives((_openBlock(), _createBlock(_component_el_table, {
                  data: _ctx.filteredList,
                  border: "",
                  class: "fs-7",
                  style: {"width":"100%"},
                  height: _ctx.altura <= 500 ? '500px' : _ctx.altura + 'px',
                  "header-cell-class-name": "text-black bg-secondary text-uppercase",
                  "highlight-current-row": "",
                  "scrollbar-always-on": ""
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      prop: "docnumber",
                      label: _ctx.t('document'),
                      width: "120"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_2, [
                          _createElementVNode("span", null, _toDisplayString(scope.row.docname), 1),
                          _hoisted_3,
                          _createElementVNode("span", null, _toDisplayString(scope.row.docnumber), 1)
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "persona",
                      label: _ctx.t('participant'),
                      width: "250"
                    }, {
                      default: _withCtx((scope) => [
                        _createElementVNode("div", _hoisted_4, [
                          _createElementVNode("div", _hoisted_5, [
                            (scope.row.photo)
                              ? (_openBlock(), _createBlock(_component_el_avatar, {
                                  key: 0,
                                  shape: "square",
                                  size: "small",
                                  fit: "contain",
                                  src: `${_ctx.REPO}/${scope.row.photo}`,
                                  class: _normalizeClass('border')
                                }, null, 8, ["src"]))
                              : _createCommentVNode("", true)
                          ]),
                          _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("span", null, _toDisplayString(scope.row.firstname), 1),
                            _hoisted_7,
                            _createElementVNode("span", null, _toDisplayString(scope.row.lastname + ' ' + scope.row.surname), 1)
                          ])
                        ])
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "gender",
                      label: _ctx.t('gender'),
                      width: "80",
                      align: "center"
                    }, {
                      default: _withCtx((scope) => [
                        (scope.row.gender == 'M')
                          ? (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(scope.row.gender), 1))
                          : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(scope.row.gender), 1))
                      ]),
                      _: 1
                    }, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      prop: "edad",
                      label: _ctx.t('age'),
                      align: "center",
                      width: "80"
                    }, null, 8, ["label"]),
                    _createVNode(_component_el_table_column, {
                      align: "center",
                      fixed: "right"
                    }, {
                      default: _withCtx((scope) => [
                        _createVNode(_component_el_button, {
                          size: "small",
                          type: "success",
                          round: "",
                          onClick: ($event: any) => (_ctx.setSelectRow(scope.row))
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.t('select')), 1)
                          ]),
                          _: 2
                        }, 1032, ["onClick"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["data", "height"])), [
                  [_directive_loading, _ctx.loaderTable]
                ]),
                _createElementVNode("span", _hoisted_10, "Encontrados: " + _toDisplayString(_ctx.filteredList.length), 1)
              ], 64))
            : (_openBlock(), _createBlock(_component_el_empty, {
                key: 1,
                class: "fw-bold",
                description: "No se encontrarón resultados",
                image: "/media/svg/illustrations/sigma/question.svg",
                "image-size": 300
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_button, {
                    type: "warning",
                    onClick: _ctx.openModalSearch
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("Clic aquí para Registrar")
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }))
        ])), [
          [_directive_loading, _ctx.loaderTable]
        ])
      ]),
      _: 1
    }, 8, ["title", "modelValue", "onOpened", "onClosed"]),
    _createVNode(_component_ModalSearch, {
      ref: "ModalSearchRef",
      idinstitution: _ctx.rowClub?.idinstitution,
      onOnResponse: _ctx.onResponse
    }, null, 8, ["idinstitution", "onOnResponse"]),
    _createVNode(_component_ModalPerfil, {
      onOnResponseMdPerfil: _ctx.geDataPayroll,
      action: _ctx.action,
      status: [],
      idinstitution: _ctx.rowClub?.idinstitution
    }, null, 8, ["onOnResponseMdPerfil", "action", "idinstitution"])
  ], 64))
}